<template>
  <div v-if="open" class="overlay" @click.self="$emit('close')">
    <div class="modal">
      <div class="modal-head">
        <div>
          <div class="eyebrow">Invitación</div>
          <h3>{{ invite?.group?.name || 'Grupo compartido' }}</h3>
        </div>
        <button class="close-btn" @click="$emit('close')">×</button>
      </div>

      <div v-if="loading" class="state-box muted">Cargando invitación…</div>
      <div v-else-if="error" class="state-box danger">{{ error }}</div>
      <template v-else-if="invite">
        <div class="group-pill">
          <span class="color-dot" :style="{ backgroundColor: invite.group?.color || '#AFCBFF' }"></span>
          <span>Te invita <strong>{{ invite.invited_by?.name || 'alguien' }}</strong></span>
        </div>

        <div class="state-box" :class="boxVariant">
          {{ invite.message }}
        </div>

        <div class="detail-grid">
          <div class="detail-card">
            <span>Grupo</span>
            <strong>{{ invite.group?.name || 'Sin nombre' }}</strong>
          </div>
          <div class="detail-card">
            <span>Invita</span>
            <strong>{{ invite.invited_by?.name || 'Alguien' }}</strong>
          </div>
          <div class="detail-card" v-if="invite.expires_at">
            <span>Vence</span>
            <strong>{{ formattedExpiry }}</strong>
          </div>
        </div>
      </template>

      <div class="actions">
        <button class="ghost-btn" @click="$emit('close')">Cerrar</button>
        <button
          v-if="invite && invite.can_accept && !invite.already_member"
          class="primary-btn"
          :disabled="loading"
          @click="$emit('accept')"
        >
          {{ loading ? 'Entrando…' : 'Aceptar invitación' }}
        </button>
        <button
          v-else-if="invite && invite.already_member"
          class="primary-btn"
          @click="$emit('close')"
        >
          Ya estoy dentro
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InviteAcceptModal',
  props: {
    open: { type: Boolean, default: false },
    invite: { type: Object, default: null },
    loading: { type: Boolean, default: false },
    error: { type: String, default: '' },
  },
  emits: ['close', 'accept'],
  computed: {
    boxVariant() {
      const code = this.invite?.error_code || '';
      if (!code) return 'info';
      if (/LIMIT|MISMATCH|EXPIRED|NOT_PENDING/.test(code)) return 'danger';
      return 'muted';
    },
    formattedExpiry() {
      const value = this.invite?.expires_at;
      if (!value) return '—';
      const date = new Date(String(value).replace(' ', 'T') + 'Z');
      if (Number.isNaN(date.getTime())) return value;
      return new Intl.DateTimeFormat('es-MX', {
        dateStyle: 'medium',
        timeStyle: 'short',
      }).format(date);
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.34);
  display: grid;
  place-items: center;
  padding: 24px;
  z-index: 45;
}
.modal {
  width: min(560px, 100%);
  background: rgba(255, 255, 255, 0.97);
  border: 1px solid rgba(148, 163, 184, 0.24);
  border-radius: 26px;
  padding: 22px;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.18);
}
.modal-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}
.eyebrow {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: #64748b;
}
h3 {
  margin: 6px 0 0;
  font-size: 30px;
  color: #0f172a;
}
.close-btn {
  border: none;
  background: transparent;
  font-size: 34px;
  color: #64748b;
  cursor: pointer;
}
.group-pill {
  margin-top: 18px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border-radius: 999px;
  background: rgba(241, 245, 249, 0.92);
  border: 1px solid rgba(148, 163, 184, 0.18);
  padding: 10px 14px;
  color: #334155;
}
.color-dot {
  width: 12px;
  height: 12px;
  border-radius: 999px;
  box-shadow: 0 0 0 1px rgba(148, 163, 184, 0.24);
}
.state-box {
  margin-top: 18px;
  border-radius: 18px;
  padding: 14px 16px;
  line-height: 1.55;
}
.state-box.info {
  background: rgba(239, 246, 255, 0.92);
  border: 1px solid rgba(96, 165, 250, 0.2);
  color: #1d4ed8;
}
.state-box.danger {
  background: rgba(254, 242, 242, 0.96);
  border: 1px solid rgba(248, 113, 113, 0.2);
  color: #991b1b;
}
.state-box.muted {
  background: rgba(248, 250, 252, 0.96);
  border: 1px solid rgba(148, 163, 184, 0.18);
  color: #475569;
}
.detail-grid {
  margin-top: 16px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 10px;
}
.detail-card {
  border-radius: 18px;
  background: rgba(248, 250, 252, 0.96);
  border: 1px solid rgba(148, 163, 184, 0.18);
  padding: 14px;
  display: grid;
  gap: 6px;
}
.detail-card span {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #64748b;
}
.detail-card strong {
  color: #0f172a;
}
.actions {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.ghost-btn,
.primary-btn {
  border: none;
  border-radius: 16px;
  padding: 12px 16px;
  font-weight: 800;
  cursor: pointer;
}
.ghost-btn {
  background: rgba(241, 245, 249, 0.96);
  color: #334155;
}
.primary-btn {
  background: #111827;
  color: white;
}
.primary-btn:disabled {
  opacity: 0.65;
  cursor: wait;
}
</style>
